import { useEffect, useRef, useState } from "react"
import { Button } from "@/components/ui/button"
import { Textarea } from "@/components/ui/textarea"

export function TranscriptReviewPanel({ initialText, onInsert, onRedo }) {
  const [text, setText] = useState(initialText || "")
  const textareaRef = useRef(null)

  useEffect(() => {
    textareaRef.current?.focus()
  }, [])

  const handleKey = (e) => {
    if (e.key === "Escape") {
      e.preventDefault()
      onRedo()
    }
  }

  return (
    <div className="mt-3 rounded-md border border-kf-red/30 bg-kf-red/5 p-4">
      <p className="text-xs uppercase tracking-wide text-zinc-600 mb-2">
        Review your transcript
      </p>
      <Textarea
        ref={textareaRef}
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={handleKey}
        rows={4}
        className="bg-white"
        aria-label="Review transcript before inserting"
      />
      <div className="flex items-center gap-2 mt-3">
        <Button
          type="button"
          variant="gradient"
          size="sm"
          onClick={() => onInsert(text)}
        >
          Insert
        </Button>
        <Button type="button" variant="ghost" size="sm" onClick={onRedo}>
          Redo
        </Button>
        <span className="text-xs text-zinc-400 ml-auto">
          Esc to redo · edit before inserting
        </span>
      </div>
    </div>
  )
}
